import { CSSProperties } from 'react';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IValueProps {
  text: string;
  style?: CSSProperties;
}

export const Value = ({ text, style }: IValueProps) => (
  <Typography
    as="span"
    color={colors.neutral[600]}
    data-testid="input-job.field.value"
    numberOfLines={1}
    style={{
      maxWidth: 240,
      ...style,
    }}
  >
    {text}
  </Typography>
);
